<template>
  <div class="column justify-center full-width full-height">
     <p class="text-center text-h5">Sorry, page could not be found</p>
     <p class="text-center text-grey-4 text-h1">404</p>
  </div>
</template>

<script>

</script>

<style scoped>

</style>
